import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ghost-loader',
    templateUrl: 'index.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class GhostLoaderComponent implements OnInit, OnChanges {
    @Input() loaderCount: any;
    @Input() loaderType: any;
    @Input() class: any;
    @Input() boxPerRow: string = 'three';
    @Input() height: string = '100px'
    @Input() width: string = 'auto'
    arrLoader: any = [];
    constructor() { }

    ngOnInit() { }
    ngOnChanges() {
        for (let i = 0; i < this.loaderCount; i++) {
            this.arrLoader.push(i)
        }
    }
}
